import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const NoteIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <path
                        fill="currentColor"
                        d="M12.22,3.19,15.4,6V16.81H4.6V3.19h7.62M12.68,2H3.4V18H16.6V5.45L12.68,2Z"
                    />
                    <polyline
                        fill="none"
                        stroke="currentColor"
                        strokeMiterlimit={10}
                        strokeWidth="1.2px"
                        x1="5.48"
                        points="12.12 2.24 12.12 6.13 16.6 6.13"
                    />
                    <rect fill="none" width="20" height="20" />
                </g>
            </g>
        </SvgIcon>
    );
};
